import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-md-center" }
const _hoisted_3 = { class: "col-12 col-md-11 col-lg-9 col-xl-7 col-xxl-6 text-center text-white" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "d-grid gap-2 d-sm-flex justify-content-sm-center mb-5"
}
const _hoisted_6 = ["href"]

import { Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Hero',
  props: {
    backGround: String,
    logo: String,
    toScroll:String,
    btntext:String,
    showBtn:Boolean,
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "bsb-hero-1 px-3 bsb-overlay bsb-hover-pull img-full blur",
    style: _normalizeStyle({ backgroundImage: 'url(' + require('@/assets/img/' + __props.backGround) + ')' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "img-fluid",
            src: require('@/assets/img/' + __props.logo),
            alt: ""
          }, null, 8, _hoisted_4),
          (__props.showBtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("a", {
                  type: "button",
                  href: `#${__props.toScroll}`,
                  class: "btn bsb-btn-xl gap-3 btn-blue"
                }, _toDisplayString(__props.btntext), 9, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 4))
}
}

})